import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const CommentDesignSettings = {
  // dimension
  'comment-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },

  // alignment
  'comment-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },

  // spacing
  'comment-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'comment-design-item-gap': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },

  // (nested) typography
  'comment-design-typography': {
    'comment-design-author-typography': {
      phone: getDefaultTypography('label-large'),
      'phone-landscape': getDefaultTypography('label-large'),
      tablet: getDefaultTypography('label-large'),
      'tablet-landscape': getDefaultTypography('label-large'),
      desktop: getDefaultTypography('label-large'),
      tv: getDefaultTypography('label-large'),
    },
    'comment-design-body-typography': {
      phone: getDefaultTypography('body-medium'),
      'phone-landscape': getDefaultTypography('body-medium'),
      tablet: getDefaultTypography('body-medium'),
      'tablet-landscape': getDefaultTypography('body-medium'),
      desktop: getDefaultTypography('body-medium'),
      tv: getDefaultTypography('body-medium'),
    },
    'comment-design-date-typography': {
      phone: getDefaultTypography('body-extra-small'),
      'phone-landscape': getDefaultTypography('body-extra-small'),
      tablet: getDefaultTypography('body-extra-small'),
      'tablet-landscape': getDefaultTypography('body-extra-small'),
      desktop: getDefaultTypography('body-extra-small'),
      tv: getDefaultTypography('body-extra-small'),
    },
    'comment-design-reply-button-typography': {
      phone: getDefaultTypography('label-medium'),
      'phone-landscape': getDefaultTypography('label-medium'),
      tablet: getDefaultTypography('label-medium'),
      'tablet-landscape': getDefaultTypography('label-medium'),
      desktop: getDefaultTypography('label-medium'),
      tv: getDefaultTypography('label-medium'),
    },
  },
  'comment-design-comment-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-comment-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-comment-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-comment-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-comment-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'comment-design-author-name-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-author-name-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-author-name-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-author-name-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-author-name-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'comment-design-author-avatar-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-author-avatar-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-author-avatar-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-author-avatar-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-author-avatar-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'comment-design-time-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-time-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-time-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-time-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-time-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'comment-design-like-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-like-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-like-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-like-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-like-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'comment-design-dislike-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'comment-design-dislike-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-dislike-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'comment-design-dislike-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'comment-design-dislike-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
}
